<table [attr.aria-label]="breakdown[0]?.label">
  @for (row of breakdown; track row; let i = $index) {
    <tr [class.small]="!row.emphasize" [class.emphasized]="row.emphasize">
      <td width="5%">
        @if (row.icon) {
          <fa-icon [icon]="row.icon" class="fa-icon me-2 me-md-0"></fa-icon>
        }
      </td>
      <th scope="row" width="55%" class="row-label">
        {{ row.label }}
        @if (row.description) {
          <br />
          <span class="fw-normal">{{ row.description }}</span>
        }
      </th>
      <td width="20%">
        {{ row.price | currency: 'EUR' : 'symbol' : '1.2-5' }}
      </td>
      <td width="20%">{{ row.suffix }}</td>
    </tr>
  }
</table>
